(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logistas-teste-forms"] && !window.DesignMode) return;
  try {
    
  const phoneInputField = document.getElementById('telefone');
  const errorMsg = document.querySelector('#msg');

  const errorMap = [
    '* número inválido',
    '* código de país inválido',
    '* número muito curto',
    '* número muito longo',
    '* número inválido',
  ];

  const phoneInput = window.intlTelInput(phoneInputField, {
    preferredCountries: ['br', 'us', 'pt'],
    separateDialCode: true,
    initialCountry: 'br',
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
  });

  phoneInputField.addEventListener('input', function () {
    let countryCode = phoneInput.getSelectedCountryData().iso2.toUpperCase();
    let formattedNumber = libphonenumber.parsePhoneNumberFromString(phoneInputField.value, countryCode);
    if (formattedNumber) {
      phoneInputField.value = formattedNumber.formatInternational();
    }
  });

  const reset = () => {
    document.getElementById('msg').innerHTML = '';
    document.getElementById('msg').style.color = '';
  };

  const showError = (msg) => {
    document.getElementById('msg').innerHTML = msg;
    document.getElementById('msg').style.color = 'red';
  };

  document.getElementById('lojaForm').addEventListener('submit', async function (event) {
    event.preventDefault();

    let parameters = document.location.search;
    let redirectUrl = new URL('https://bluwe.com.br/pages/lojistas-obrigado' + parameters);
    let utm_medium = redirectUrl.searchParams.get('utm_medium');
    let utm_source = redirectUrl.searchParams.get('utm_source');
    let utm_campaign = redirectUrl.searchParams.get('utm_campaign');
    let utm_content = redirectUrl.searchParams.get('utm_content');
    
    const formData = {
      nome_completo: document.getElementById('nome_completo').value,
      nome_loja: document.getElementById('nome_loja').value,
      cnpj: document.getElementById('cnpj').value,
      email: document.getElementById('email').value,
      uf: document.getElementById('uf').value,
      instagram: document.getElementById('instagram').value,
      telefone: phoneInput.getNumber(),
      _utm_medium: utm_medium,
      _utm_content: utm_content,
      _utm_campaign: utm_campaign,
      _utm_source: utm_source,
    };

    if(!formData.nome_completo || !formData.nome_loja || !formData.cnpj || !formData.email || !formData.uf || !formData.instagram || !phoneInput.isValidNumber()) {
      showError('* preencha todos os campos corretamente');
      return;
    }
    document.getElementById("submit-button").disabled = true;
    const url = 'https://bluwe-n8n-u20399.vm.elestio.app/webhook/f001b036-4425-4a99-905b-758ed6288ad3';

    const headers = new Headers();
    headers.append('Authorization', 'Basic ' + btoa('kommo:kommo'));
    headers.append('Content-Type', 'application/json');

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(formData),
      });

      if (response.ok && phoneInput.isValidNumber()) {
        if (typeof fbq !== 'undefined') fbq('track', 'Lead');

        window.location.assign(redirectUrl.href);
      } else {
        document.getElementById("submit-button").disabled = true;
        document.getElementById('msg').innerHTML = 'Erro ao enviar cadastro!';
        document.getElementById('msg').style.color = 'red';
      }
    } catch (error) {
      document.getElementById("submit-button").disabled = true;
      document.getElementById('msg').innerHTML = 'Erro na integração!';
      document.getElementById('msg').style.color = 'red';
    }
  });

  document.getElementById('cnpj').addEventListener('input', function (e) {
    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
    e.target.value = !x[2] ? x[1] : x[1] + '.' + x[2] + '.' + x[3] + '/' + x[4] + (x[5] ? '-' + x[5] : '');
  });

  phoneInputField.addEventListener('keyup', () => {
    reset();
    if (!phoneInputField.value.trim()) {
      showError('* preencha esse campo');
    } else if (phoneInput.isValidNumber()) {
    } else {
      const errorCode = phoneInput.getValidationError();
      const msg = errorMap[errorCode] || '* numero invalido';
      showError(msg);
    }
  });

  phoneInputField.addEventListener('change', reset);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-easy-coding"] && !window.DesignMode) return;
  try {
    
$('.slider').each(function() {
  var $this = $(this);
  var $group = $this.find('.slide_group');
  var $slides = $this.find('.slide');
  var bulletArray = [];
  var currentIndex = 0;
  var timeout;
  
  function move(newIndex) {
    var animateLeft, slideLeft;
    
    advance();
    
    if ($group.is(':animated') || currentIndex === newIndex) {
      return;
    }
    
    bulletArray[currentIndex].removeClass('active');
    bulletArray[newIndex].addClass('active');
    
    if (newIndex > currentIndex) {
      slideLeft = '100%';
      animateLeft = '-100%';
    } else {
      slideLeft = '-100%';
      animateLeft = '100%';
    }
    
    $slides.eq(newIndex).css({
      display: 'block',
      left: slideLeft
    });
    $group.animate({
      left: animateLeft
    }, function() {
      $slides.eq(currentIndex).css({
        display: 'none'
      });
      $slides.eq(newIndex).css({
        left: 0
      });
      $group.css({
        left: 0
      });
      currentIndex = newIndex;
    });
  }
  
  function advance() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      if (currentIndex < ($slides.length - 1)) {
        move(currentIndex + 1);
      } else {
        move(0);
      }
    }, 6000);
  }
  
  $('.next_btn').on('click', function() {
    if (currentIndex < ($slides.length - 1)) {
      move(currentIndex + 1);
    } else {
      move(0);
    }
  });
  
  $('.previous_btn').on('click', function() {
    if (currentIndex !== 0) {
      move(currentIndex - 1);
    } else {
      move(3);
    }
  });
  
  $.each($slides, function(index) {
    var $button = $('<a class="slide_btn">&bull;</a>');
    
    if (index === currentIndex) {
      $button.addClass('active');
    }
    $button.on('click', function() {
      move(index);
    }).appendTo('.slide_buttons');
    bulletArray.push($button);
  });
  
  advance();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-swiper"] && !window.DesignMode) return;
  try {
    
    const swiper = new Swiper('.swiper', {
      effect: 'slide',
      loop: true,
      centeredSlides: true,
      direction: 'horizontal',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-unlimited"] && !window.DesignMode) return;
  try {
    
  const handleBlk = (className) => {
    const blocks = [];
    const elements = document.querySelectorAll(`[class="${className}"]`);

    elements.forEach((elem) => {
      blocks.push({
        type: elem.dataset.type,
        link: elem.dataset.link,
        utm: elem.dataset.utm,
        image: elem.dataset.img,
        atributes: elem.dataset.attr,
      });
      elem.remove();
    });

    return blocks;
  };

  const readUtms = () => {
    const params = new URLSearchParams(window.location.search);
    const utms = {};

    params.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        utms[key] = value;
      }
    });

    return utms;
  };

  const getCookie = (name) => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [cookieName, ...rest] = cookie.split('=');
      if (cookieName === name) {
        return { name, value: rest.join('=') };
      }
    }
    return null;
  };

  window.addEventListener('load', () => {
    const utms = readUtms();
    const blocks = handleBlk('utm-banner-hidden');

    blocks.forEach(({ type, utm, link, image, atributes }) => {
      const [utmKey, utmExpectedValue] = utm.split('=');
      const cookie = getCookie(utmKey);
      const urlUtmValue = utms[utmKey];

      const matchesCookie = cookie?.value === utmExpectedValue;
      const matchesUrlParam = urlUtmValue === utmExpectedValue;

      if (matchesCookie || matchesUrlParam) {
        const swiperSelector = type === 'desktop' ? '#swiper-desktop' : '#swiper-mobile';
        const swiperContainer = document.querySelector(swiperSelector);

        if (swiperContainer) {
          swiperContainer.innerHTML += `
        <a class="swiper-slide" id="bn-swiper-slide" href="${link}" ${atributes || ''}>
          <img src="${image}" alt="">
        </a>`;
        }
      }
    });

    new Swiper('.swiper', {
      effect: 'slide',
      loop: true,
      centeredSlides: true,
      direction: 'horizontal',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
